module.exports = __webpack_public_path__ + "static/img/NSW-4.7be8f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-4.jpg
// module id = Y0h7
// module chunks = 0